if (!customElements.get('rest-landing')) {
  customElements.define('rest-landing', class extends HTMLElement {
    connectedCallback() {
      this.purchase = this.querySelector('[data-rest-purchase]');
      this.sticky = this.querySelector('[data-rest-sticky]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.variantSelect = this.querySelector('[data-rest-variant]');
      this.planInput = this.querySelector('[data-rest-selling-plan]');
      this.planSelect = this.querySelector('[data-rest-selling-plan-select]');
      this.querySelectorAll('[data-rest-purchase-type]').forEach((radio) => radio.addEventListener('change', () => {
        const subscription = radio.value === 'subscription';
        if (this.planInput) {
          this.planInput.disabled = !subscription;
          if (subscription) this.planInput.value = this.planSelect?.value || this.planInput.defaultValue;
        }
        this.planSelect?.toggleAttribute('disabled', !subscription);
        this.querySelectorAll('.rest-plan-option').forEach((option) => option.classList.toggle('is-selected', option.contains(radio)));
      }));
      this.planSelect?.addEventListener('change', () => { if (this.planInput) this.planInput.value = this.planSelect.value; });
      this.variantSelect?.addEventListener('change', () => {
        const formVariant = this.purchase.querySelector('.product-variant-id');
        if (formVariant) {
          formVariant.value = this.variantSelect.value;
          formVariant.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const selected = this.variantSelect.selectedOptions[0];
        const regularPrice = this.querySelector('.rest-launch-price s');
        const launchPrice = this.querySelector('.rest-launch-price strong');
        if (regularPrice && selected?.dataset.price) regularPrice.textContent = selected.dataset.price;
        if (launchPrice && selected?.dataset.launchPrice) launchPrice.textContent = selected.dataset.launchPrice;
        const stickyPrice = this.querySelector('.rest-sticky__meta span');
        if (stickyPrice && selected?.dataset.price) stickyPrice.textContent = selected.dataset.price;
      });
      this.querySelectorAll('[data-rest-scroll]').forEach((button) => button.addEventListener('click', () => {
        this.purchase?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        this.purchase?.querySelector('button, input, select')?.focus({ preventScroll: true });
      }));
      if (this.purchase && this.sticky && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => this.updateSticky(!entry.isIntersecting), { threshold: 0.15 });
        this.observer.observe(this.purchase);
      }
      document.addEventListener('cart:open', this.hideSticky);
      this.querySelectorAll('[data-cro-source]').forEach((element) => element.addEventListener('click', () => {
        document.documentElement.dataset.restCtaSource = element.dataset.croSource;
      }));
    }
    hideSticky = () => this.sticky?.classList.remove('is-visible');
    updateSticky(show) {
      const drawerOpen = this.cartDrawer?.classList.contains('active') || this.cartDrawer?.hasAttribute('open');
      this.sticky.classList.toggle('is-visible', show && !drawerOpen);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
